const TIERS = ['development', 'staging', 'production'] as const

export type TStatsigTier = (typeof TIERS)[number]

/**
 * MYQRCODE-10817 AC#3 — the tier is passed explicitly via
 * NEXT_PUBLIC_STATSIG_ENVIRONMENT, set per environment alongside the Statsig keys.
 * An absent or unrecognised value disables Statsig entirely rather than
 * defaulting to production, so callers must treat `null` as "do not
 * initialise" rather than substituting a tier of their own.
 */
export const resolveStatsigTier = (
	raw: string | undefined,
): TStatsigTier | null =>
	TIERS.includes(raw as TStatsigTier) ? (raw as TStatsigTier) : null
